import {Controller} from "@hotwired/stimulus";

const HIDDEN_CLASS = "service-menu--hidden";

export default class extends Controller {
    static targets = ["menu", "menuToggle"]

    // workaround to type readonly element
    // this will return the element that was detected as controller
    get el(): HTMLElement {
        return this.element as HTMLElement;
    }

    menuTarget!: HTMLElement;
    menuToggleTarget!: HTMLElement;

    connect() {
        // we need to disable animation so that the menu visibility
        // can be change instantly -> import when moving to a different side
        // and the menu should not be visible because it was already seen by
        // the user.
        this._disableAnimation();
        let serviceMenuIsClosed = localStorage.getItem("serviceMenuIsClosed");
        // check override-state-classes on the element (can be set for each page in neos backend)
        if(this.el.classList.contains('service-menu--force-open')) {
            serviceMenuIsClosed = "false";
        }
        if(this.el.classList.contains('service-menu--force-close')) {
            serviceMenuIsClosed = "true";
        }

        if (serviceMenuIsClosed === "true") {
            this.el.classList.add(HIDDEN_CLASS);
        }

        window.addEventListener('resize', this._updateMargin.bind(this));

        window.setTimeout(() => {
            // wait a bit to ensure the js gets the correct height of the service menu
            if (!this.menuTarget.style.display) {
                this.menuTarget.style.display = "block";
                this._updateMargin();
            }
        }, 800)
    }

    toggle() {
        // enable animation on first/every click
        this._enableAnimation();

        this.el.classList.toggle(HIDDEN_CLASS);
        this._updateMargin();

        const isClosed = this.el.classList.contains(HIDDEN_CLASS);
        localStorage.setItem("serviceMenuIsClosed", (isClosed ? "true" : "false"))
    }

    _disableAnimation() {
        this.menuTarget.style.transitionProperty = "none";
        this.menuToggleTarget.style.transitionProperty = "none";
    }

    _enableAnimation() {
        this.menuTarget.style.transitionProperty = "margin-top";
        this.menuToggleTarget.style.transitionProperty = "margin-top";
    }

    _updateMargin() {
        const height = this._getMenuHeight()
        // IMPORTANT: working with a negative margin seems to be the most robust way
        // as it will not mess with the height in any way, which we need to correctly
        // hide/show the menu and recalculate on window resize. Changing the height
        // instead in combination with `overflow:hidden` will lead to all kinds of
        // problems.
        if (this.el.classList.contains(HIDDEN_CLASS)) {
            this.menuTarget.style.marginTop = `${-height}px`;
        } else {
            this.menuTarget.style.marginTop = `${0}px`;
        }
    }

    _getMenuHeight() {
        return this.menuTarget.clientHeight;
    }
}
